module.exports = {"id":"s6-q3","text":"Do you have access to a smart phone with internet access?","multiselect":false,"options":[{"id":"s6-q3-a1","text":"Yes","next":"s6-q4","capability":1,"access":1,"focusarea":[0,0,0,0,2]},{"id":"s6-q3-a2","text":"No","next":"finish","capability":-4,"access":-4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q3.json
// module id = 918
// module chunks = 41